import { initUrgency } from './urgency.js';
import { initCart } from './cart.js';
import { initUpsell } from './upsell.js';
import { initPromo } from './promo.js';
import { initTotals } from './totals.js';

/**
 * Orchestrator for the right-hand summary column. Each child owns its DOM
 * fragment + subscribes to its own state slice; this file just wires them up.
 */
export function initSummary() {
  // initShipBanner() intentionally not called — the free-shipping offer is
  // paused (2026-08-16). shipBanner.js is kept so restoring is a one-line change.
  initUrgency();
  initCart();
  initUpsell();
  initPromo();
  initTotals();
}
